import { render } from "./customer-detail.vue?vue&type=template&id=eb8c5786"
import script from "./customer-detail.vue?vue&type=script&lang=js"
export * from "./customer-detail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__